export const STORE_LOCATOR_PAGE_QUERY = `query GetInfoPageBannerCTA {
  informationalPageCollection(where: {title_contains: "store Locator"}) {
    items {
      contentSectionsCollection(limit: 3) {
        items {
          __typename
          ... on InformationalPageBannerWithCta {
            title
            description
            cta {
              buttonText
            }
            responsiveBannerImage {
              title
              md {
                url
              }
            }
          }
          ... on InformationPageBannerWithRichText {
            title
            richTextDescription: description {
              json
            }
            responsiveBannerImage {
              title
              md {
                url
              }
            }
          }
          ... on InformationalPageNavigationSection {
            title
            storeLocatorPageStates
          }
        }
      }
    }
  }
}`;